var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGenericos = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 22H3.11111C2.5 22 2 21.5 2 20.8889V3.11111C2 2.5 2.5 2 3.11111 2H20.8889C21.5 2 22 2.5 22 3.11111V20.8889C22 21.5 21.5 22 20.8889 22Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 2H13.6666V5.88889H10.3333V2Z",
    fill: "#FFD966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 19.2222H19.7778V19.7778H14.7778V19.2222ZM18.1112 16.4445H19.2223V18.6667H18.1112V16.4445Z",
    fill: "#B86D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 15.3333L17.5555 17H19.7777L18.6666 15.3333ZM15.3333 16.4444H16.4444V18.6666H15.3333V16.4444Z",
    fill: "#B86D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 15.3333L14.7778 17H17.0001L15.8889 15.3333Z",
    fill: "#B86D00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGenericos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Genericos.3bdae04a.svg";
export { ForwardRef as ReactComponent };